import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CmSvgIcon = _resolveComponent("CmSvgIcon")!

  return (_openBlock(), _createBlock(_component_CmSvgIcon, {
    name: "assets/icons/info-1",
    class: "blue-tips-icon",
    size: _ctx.size,
    style: { color: 'var(--el-color-primary)' }
  }, null, 8, ["size"]))
}